import type { FeatureFlagId } from "@/config/environment";

import { getEnvironmentValues } from "@/config/environment";
import { useGetCurrentUser } from "@/entities/current-user";

export const useFeatureFlag = (featureId: FeatureFlagId) => {
  const { currentUser } = useGetCurrentUser();
  const environmentValues = getEnvironmentValues();
  const currentUserEmail = (currentUser?.email ?? "").toLowerCase();

  // Example of envVarValue:
  // "true | info@stelar.ai, chuck.norris@norda.com"
  const envVarValue = (environmentValues[featureId] as string) ?? "";
  const parts = envVarValue.split("|");
  const isFeatureActivated = parts[0].trim().toLowerCase() === "true";

  if (!isFeatureActivated || parts.length === 1) {
    return isFeatureActivated;
  }

  const emails = parts[1].split(",").map((email) => email.trim().toLowerCase());
  return emails.includes(currentUserEmail);
};
